import { useContext } from "react";
import Tab from "@common/components/Tab";
import Grid from "@mui/material/Grid2";
import Tabs from "@common/components/Tabs";
import Typography from "@common/components/Typography";
import { useTranslation } from "react-i18next";
import { FormLabel } from "@mui/material";
import { getTestId } from "@common/utils/getTestId";
import { ViewTabContext } from "./context";

const ViewsTabs = () => {
  const { tabs, note, selectedTab, setSelectedTab } =
    useContext(ViewTabContext);
  const { t } = useTranslation();

  return (
    <Grid>
      <Grid
        container
        wrap="nowrap"
        direction="row"
        sx={{ width: "100%", alignItems: "center", gap: "1rem" }}
      >
        {note && (
          <Typography sx={{ color: "gray" }} data-testid="tabs-note">
            {note}
          </Typography>
        )}
        <Tabs
          value={selectedTab}
          onChange={(_, value) => setSelectedTab(value)}
        >
          {tabs.map((value) => (
            <Tab
              key={value.name}
              label={
                <FormLabel required={value.required}>{t(value.name)}</FormLabel>
              }
              value={value.name}
              disabled={value.disabled}
              tooltip={value.tooltip ? t(value.tooltip) : ""}
              sx={{
                "&.Mui-disabled": {
                  "& .MuiFormLabel-root": {
                    cursor: "default",
                    color: "text.disabled",
                  },
                },
                "& .MuiFormLabel-root": {
                  cursor: "pointer",
                  color: "text.primary",
                },
              }}
              data-testid={`${getTestId(value.name)}-tab`}
            />
          ))}
        </Tabs>
      </Grid>
    </Grid>
  );
};

export default ViewsTabs;
